module.exports = __webpack_public_path__ + "img/xxx-bcg.346361f.png";